import PatchLists from "../../patchlists.js";

export default class PagePatchlistsPublic
{
    constructor()
    {
        this.patchLists = new PatchLists();
    }
}
